import { useFiltersStore } from '@/hooks'
import { mapAnalyticsFiltersGetParams } from '../stores/useAnalyticsStore/mapAnalyticsFiltersGetParams'
import { ReportFiltersValues } from '../stores/useAnalyticsFiltersStore/types'
import { useMemo } from 'react'

export const useAnalyticsFiltersGetParams = (
    activeAnalyticsFilters: ReportFiltersValues
) => {
    const rootNode = useFiltersStore((state) => state.rootNode)

    return useMemo(() => {
        const analyticsFiltersParams = mapAnalyticsFiltersGetParams(
            activeAnalyticsFilters
        )

        if (!analyticsFiltersParams['nodeIds[]'] && rootNode) {
            analyticsFiltersParams['nodeIds[]'] = rootNode.nodeId.toString()
        }

        return analyticsFiltersParams
    }, [activeAnalyticsFilters, rootNode])
}
